import { render } from "./DragDropCard.vue?vue&type=template&id=1ed4e78a"
import script from "./DragDropCard.vue?vue&type=script&lang=js"
export * from "./DragDropCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__